module.exports = __webpack_public_path__ + "static/media/home_medication.9f0759ff.png";